export default "__VITE_PUBLIC_ASSET__8928708f__"